import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

import Dashboard from './Pages/Dashboard'
import Login from './Pages/Login'
import './index.css'
import { Provider } from "react-redux";
import { store } from "./redux/store";
import KpiRatings from "./Pages/KpiRatings";
import Companies from "./Pages/Companies";
import RatingsData from "./Pages/RatingsData";

const router = createBrowserRouter([
  // {
  //   path: "/",
  //   element: <Home />,
  // },
  // {
  //   path: "/qldEoi",
  //   element: <QldEoi />,
  // },
  // {
  //   path: "/declaration",
  //   element: <Declaration />,
  // },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/kpiRatings",
    element: <KpiRatings />,
  },
  {
    path: "/ratingsData",
    element: <RatingsData />,
  },
  {
    path: "/companies",
    element: <Companies />,
  },
  {
    path: "/login",
    element: <Login />,
  }
])

createRoot(document.getElementById("root")).render(
  <>
    <Provider store={store()}>
      <RouterProvider router={router} />
      <ToastContainer />
    </Provider>
  </>
);